import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps } from '@/router/helpers/validations'

export default [{
	path: routeList.SAVINGS_BASE_PATH,
	beforeEnter (to, from, next) {
		next(false)
	}
},
/* ***********************************************
*                    MY SAVINGS                  *
*********************************************** */
{
	path: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME,
	component: () => import('@/views/savings/mySavings/Portfolio')
}, {
	path: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_CHARGE_NAME,
	props: true,
	component: () => import('@/views/savings/mySavings/ChargeDP'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME)
	}
}, {
	path: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_MOBILIZE_NAME,
	props: true,
	component: () => import('@/views/savings/mySavings/MobilizeDP'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.SAVINGS_MY_SAVINGS_PORTFOLIO_NAME)
	}
}, {
	path: routeList.SAVINGS_MY_SAVINGS_PIGGY_BANK_PATH,
	name: routeList.SAVINGS_MY_SAVINGS_PIGGY_BANK_NAME,
	component: () => import('@/views/UnderDevelopment')
},
/* ***********************************************
*                     PRODUCTS                   *
*********************************************** */
{
	path: routeList.SAVINGS_PRODUCTS_PATH,
	name: routeList.SAVINGS_PRODUCTS_NAME,
	component: () => import('@/views/savings/products/ProductsList')
}, {
	path: routeList.SAVINGS_PRODUCTS_CONSTITUTE_PATH,
	name: routeList.SAVINGS_PRODUCTS_CONSTITUTE_NAME,
	props: true,
	component: () => import('@/views/savings/products/Constitute'),
	beforeEnter (to, from, next) {
		validateRouteMandatoryProps(to, from, next, routeList.SAVINGS_PRODUCTS_NAME)
	}
},
/* ***********************************************
*                      HISTORY                   *
*********************************************** */
{
	path: routeList.SAVINGS_HISTORY_PATH,
	name: routeList.SAVINGS_HISTORY_NAME,
	beforeEnter (to, from, next) {
		next(false)
	}
}, {
	path: routeList.SAVINGS_HISTORY_PORTFOLIO_PATH,
	name: routeList.SAVINGS_HISTORY_PORTFOLIO_NAME,
	component: () => import('@/views/savings/history/Portfolio')
}, {
	path: routeList.SAVINGS_HISTORY_OBJECTIVES_PATH,
	name: routeList.SAVINGS_HISTORY_OBJECTIVES_NAME,
	component: () => import('@/views/UnderDevelopment')
}]
